import axios from 'axios'
import cookie from 'vue-cookie'
import { checklistApi } from '@/plugins/checklist_api'

export default {
  login ({ commit }, loginModel) {
    return new Promise((resolve, reject) => {
      axios.post('auth', loginModel).then(response => {
        var date = new Date()
        date.setDate(date.getDate() + 4)
        // eslint-disable-next-line camelcase
        const { id, name, token, role_id, email } = response.data
        const user = JSON.stringify({ id, name, role_id, email })
        cookie.set(process.env.VUE_APP_TOKEN, token, { expires: date, SameSite: 'Strict' })
        cookie.set(process.env.VUE_APP_USER, user, { expires: date, SameSite: 'Strict' })
        commit('authLogin', { authToken: token, user: JSON.parse(user) })
        axios.defaults.headers.common.Authorization = `Bearer ${token}`
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout ({ commit }) {
    cookie.delete(process.env.VUE_APP_TOKEN)
    cookie.delete(process.env.VUE_APP_USER)
    commit('logout')
  },
  deleteHandler ({ commit }, model) {
    return new Promise((resolve, reject) => {
      const modelObj = { data: { ids: model.ids } }
      if (model.fromCheckList) {
        checklistApi.delete(model.url, modelObj)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        axios.delete(model.url, modelObj)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      }
    })
  },
  deleteSingleRecordHandler ({ commit }, model) {
    return new Promise((resolve, reject) => {
      axios.delete(model.url)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * GET ALL WORKFLOW STATES
   */
  getAllWorkflowStates ({ commit }) {
    return new Promise((resolve, reject) => {
      const query = {
        select: ['id', 'name'],
        filter: 'active eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('workflowstates/query', query)
        .then(response => {
          commit('setWorkflowList', response.data)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRODUCT UNITS
   */
  getUnits ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('productunits/query', model)
        .then((response) => {
          const model = { type: 'listOfUnits', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SALES ACCOUNT
   */
  getSalesAccount ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('salesaccounts/query', model)
        .then((response) => {
          const model = { type: 'listOfSalesAccounts', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEPARTMENTS
   */
  getDepartments ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('departments/query', model)
        .then((response) => {
          const model = { type: 'listOfDepartments', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL WORKFLOWS
   */
  getWorkflows ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('productworkflows/query', model)
        .then((response) => {
          const model = { type: 'listOfWorkflows', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRODUCT CLASSES
   */
  getProductClasses ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('productclasses/query', model)
        .then((response) => {
          const model = { type: 'listOfProductClasses', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL USERS
   */
  getUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'is_active eq 1 AND is_employee eq 1'
      }
      axios.post('users/query', model)
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.fullname = element.name
            })
          }
          const model = { type: 'listOfUsers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL MAILBOX
  */
  getMailbox ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        select: ['id', 'name']
      }
      axios.post('mailconfigurations/query', model)
        .then((response) => {
          const model = { type: 'listOfMailboxes', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL STATUS
  */
  getStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('ticketstatuslists/query', model)
        .then((response) => {
          const model = { type: 'listOfStatus', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRIORITY
  */
  getPriority ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('priorities/query', model)
        .then((response) => {
          const model = { type: 'listOfPriorities', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer PRIORITY
  */
  getCustomerPriority ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('customerpriorities/query', model)
        .then((response) => {
          const model = { type: 'listOfCustomerPriorities', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer Industry
  */
  getCustomerIndustry ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('customerindustries/query', model)
        .then((response) => {
          const model = { type: 'listofCustomerIndustries', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL Customer SHIPMENTS
  */
  getCustomerShipment ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1'
      }
      axios.post('customershipments/query', model)
        .then((response) => {
          const model = { type: 'listofCustomerShipments', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL TYPES
  */
  getTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('tickettypes/query', model)
        .then((response) => {
          const model = { type: 'listOfTypes', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL ROLES
  */
  getUserRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('userroles/query', model)
        .then((response) => {
          const model = { type: 'listOfUserRoles', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL GROUPS
  */
  getGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {}
      axios.post('groups/query', model)
        .then((response) => {
          const model = { type: 'listOfGroups', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL PRODUCT GROUPS
  */
  getProductGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        order_by: {
          field: 'number',
          asc_or_desc: 'asc'
        },
        filter: 'isactive eq 1'
      }
      axios.post('productgroups/query', model)
        .then((response) => {
          const model = { type: 'listOfProductGroups', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
    * GET ALL DEVIATION CATEGORY
  */
  getDeviationCategory ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationcategories/query', model)
        .then((response) => {
          const model = { type: 'listOfDevationCategory', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEVIATION STATUS
  */
  getDeviationStatus ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationstatuses/query', model)
        .then((response) => {
          const model = { type: 'listOfDevationStatus', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL DEVIATION LOCATION
  */
  getDeviationLocation ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('deviationlocations/query', model)
        .then((response) => {
          const model = { type: 'listOfDevationLocation', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SUPPLIERS
  */
  getSupplierList ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1 AND issupplier eq 1',
        order_by: {
          field: 'name',
          asc_or_desc: 'asc'
        }
      }
      axios.post('customers/query', model)
        .then((response) => {
          const model = { type: 'listOfSuppliers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL SUPPLIERS
  */
  getCustomersList ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        order_by: {
          field: 'name',
          asc_or_desc: 'asc'
        },
        filter: 'isactive eq 1 AND iscustomer eq 1'
      }
      axios.post('customers/query', model)
        .then((response) => {
          const model = { type: 'listOfCustomers', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL CURRENCY
  */
  getCurrencyList ({ commit }) {
    return new Promise((resolve, reject) => {
      const query = {
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('currencies/query', query)
        .then((response) => {
          const model = { type: 'listOfCurrency', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL WAREHOUSE
   */
  getWarehouse ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: { field: 'name', asc_or_desc: 'asc' }
      }
      axios.post('warehouses/query', model)
        .then((response) => {
          const model = { type: 'listOfWarehouse', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  },
  /**
   * GET ALL WAREHOUSE LOCATIONS
   */
  getWarehouseLocations ({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        filter: 'isactive eq 1',
        order_by: {
          field: 'name',
          asc_or_desc: 'asc'
        }
      }
      axios.post('warehouselocations/query', model)
        .then((response) => {
          const model = { type: 'listOfLocations', data: response.data }
          commit('listValues', model)
          resolve()
        })
    })
  }
}
